interface BackButtonProps {
  onBack: () => void;
}

export default function BackButton({ onBack }: BackButtonProps) {
  return (
    <button
      onClick={onBack}
      className="absolute top-11 left-7 flex size-10 items-center justify-center rounded-full bg-white hover:bg-gray-100"
    >
      <img src="/agent/icon-arrow-left-gray.svg" alt="戻る" width="20" height="20" />
    </button>
  );
}
